import cropApplicationService from "./cropApplicationService";
import cropApplicationDraftService from "./cropApplicationDraftService";

const cropApplicationTypeService = [
    ...cropApplicationService,
    ...cropApplicationDraftService
];

export default cropApplicationTypeService;